import { ReadyLoopClient } from '@readyloop/sdk';
import { API_BASE } from './api-base';

export const readyLoopClient = new ReadyLoopClient({ apiUrl: API_BASE });
